import isPropValid from "@emotion/is-prop-valid";
import styled from "styled-components";
export const Content = styled.div.withConfig({
    shouldForwardProp: isPropValid,
}) `
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding-right: 1px;
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29udGVudC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1Njcm9sbGJhci9zdHlsZWQvQ29udGVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLFdBQVcsTUFBTSx3QkFBd0IsQ0FBQztBQUNqRCxPQUFPLE1BQU0sTUFBTSxtQkFBbUIsQ0FBQztBQUV2QyxNQUFNLENBQUMsTUFBTSxPQUFPLEdBQUcsTUFBTSxDQUFDLEdBQUcsQ0FBQyxVQUFVLENBQUM7SUFDM0MsaUJBQWlCLEVBQUUsV0FBVztDQUMvQixDQUFDLENBQUE7Ozs7O0NBS0QsQ0FBQyJ9